import { createFileRoute } from "@tanstack/react-router"
import { BackofficeOrganizationCredits } from "modules/backoffice/components/organizations/credits"

export const Route = createFileRoute("/_base/_auth/backoffice/organizations/$id/credits/list")({
  component: BackofficeOrganizationCredits,
})
